// extracted by mini-css-extract-plugin
module.exports = {"wavetop":"UserForm_wavetop__2ohy8","nav":"UserForm_nav__1lFKZ","navbar":"UserForm_navbar__32qIy","cards":"UserForm_cards__1Ws-O"};